export default {"src":"/_next/static/media/alta-bg-tr.cb049a23.svg","height":380,"width":390,"blurWidth":0,"blurHeight":0};